import React from 'react'
import PublicLayout from '@/pages/PublicLayout';
import Simple from '@/components/layouts/AuthLayout/Simple';
import Subscribe from '@/components/pages/auth/Subscribe/Subscribe';
import { Head } from '@inertiajs/react';

const SubscribePage = () => {
  return (
    <>
      <Head>
        <title>Subscribe to Updates</title>
        <meta name="description" content="Subscribe to Memo Slate updates and be the first to know about new features, security updates, and improvements to our secure note-taking platform." />
      </Head>
      <Simple>
        <Subscribe />
      </Simple>
    </>
  );
}

SubscribePage.layout = (page: React.ReactNode) => <PublicLayout children={page} />;
export default SubscribePage;

